module.exports = __webpack_public_path__ + "img/goods15_2.a0df2b94.jpg";